import { listen } from 'coframe'

import * as types from '@script/types'

export const events = listen<types.InternalEvents>('truework-js')
export type Events = typeof events
